<template>
	<a class='UserComponent' :href='`/profile/${notification.user.id}/`'>{{notification.user.name}}</a>
</template>

<script>
export default {
	name:  'UserComponent',
	props: {
		notification: {
			type: Object
		}
	}
};
</script>
